import React, { useState, useEffect } from "react";
import { axiosInstance } from "../Component/utils/axiosInstance";
import Layout from "../Component/Layout/Layout";
import BannerSection from "../Component/BannerSection";
import Loader from "../Component/Loader";

const Discount = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDiscounts = async () => {
      try {
        const response = await axiosInstance.get("/user/all/coupon");
        if (response.data.status && response.data.coupons) {
          setDiscounts(response.data.coupons);
        } else {
          setError("No discounts found");
        }
      } catch (err) {
        setError("Failed to fetch discounts");
        console.error("Error fetching discounts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDiscounts();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="alert alert-danger mt-5">{error}</div>;
  }

  return (
    <>
      <style>
        {`
      /* For WebKit browsers (Chrome, Safari) */
      .table-responsive::-webkit-scrollbar {
        height: 8px;
        background-color: #f5f5f5;
      }
      .table-responsive::-webkit-scrollbar-thumb {
        background-color: #cd2128;
        border-radius: 4px;
      }
      .table-responsive::-webkit-scrollbar-track {
        background-color: #f5f5f5;
      }
      
      /* For Firefox */
      .table-responsive {
        scrollbar-width: thin;
        scrollbar-color: #cd2128 #f5f5f5;
      }
    `}
      </style>
      <Layout>
        <BannerSection
          heading="Available Discounts"
          description="Available Discounts"
          path="/"
        />
        <div
          className="container py-5 my-md-3"
          style={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            maxWidth: "98%", // Slightly reduce container width on mobile
          }}
        >
          <h2
            className="mb-4"
            style={{
              color: "#cd2128",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "1px",
              fontSize: "clamp(1.25rem, 3vw, 1.75rem)", // Responsive font size
            }}
          >
            Available Discounts
          </h2>

          <div
            className="table-responsive"
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
              border: "1px solid #eee",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <table
              className="table mb-0"
              style={{
                minWidth: "650px", // Ensures table doesn't collapse too much
                border: "none",
              }}
            >
              <thead
                style={{
                  backgroundColor: "#cd2128",
                  color: "#fff",
                  position: "sticky",
                  top: 0,
                }}
              >
                <tr>
                  <th
                    scope="col"
                    style={{
                      padding: "12px 15px",
                      fontSize: "clamp(0.8rem, 1.5vw, 1rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Code
                  </th>
                  <th
                    scope="col"
                    style={{
                      padding: "12px 15px",
                      fontSize: "clamp(0.8rem, 1.5vw, 1rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Discount
                  </th>
                  <th
                    scope="col"
                    style={{
                      padding: "12px 15px",
                      fontSize: "clamp(0.8rem, 1.5vw, 1rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Valid Until
                  </th>
                  <th
                    scope="col"
                    style={{
                      padding: "12px 15px",
                      fontSize: "clamp(0.8rem, 1.5vw, 1rem)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {discounts.map((discount) => (
                  <tr
                    key={discount.id}
                    style={{
                      borderBottom: "1px solid #eee",
                      fontSize: "clamp(0.8rem, 1.5vw, 1rem)", // Responsive font
                    }}
                  >
                    <td
                      style={{
                        padding: "12px 15px",
                        fontWeight: "600",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          color: "#cd2128",
                          display: "inline-block",
                        }}
                      >
                        {discount.code}
                      </span>
                    </td>
                    <td style={{ padding: "12px 15px", whiteSpace: "nowrap" }}>
                      <span
                        style={{
                          backgroundColor: "rgba(205, 33, 40, 0.1)",
                          padding: "5px 10px",
                          borderRadius: "20px",
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                      >
                        {discount.percent}%
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "12px 15px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {new Date(discount.end_date).toLocaleDateString()}
                    </td>
                    <td style={{ padding: "12px 15px", whiteSpace: "nowrap" }}>
                      {new Date() < new Date(discount.end_date) ? (
                        <span style={{ color: "#28a745", fontWeight: "700" }}>
                          Valid
                        </span>
                      ) : (
                        <span style={{ color: "#dc3545", fontWeight: "700" }}>
                          Expired
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Scroll hint for mobile users */}
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              color: "#666",
              fontSize: "0.8rem",
              display: window.innerWidth < 768 ? "block" : "none", // Only show on mobile
            }}
          >
            ← Scroll to view more →
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Discount;
